import axios from 'axios';
import moment from 'moment';

const DISCORD_WEBHOOK_URL = 'https://discord.com/api/webhooks/1310953187150135357/SjjN_3hOSWPrDLZ55ZGiQQ3-jIsbY28qtw-UHpzb8QQTzBMBhK7Xdo6KzLAo_Dyvgd_s';

interface WebhookUser {
  email: string;
  name: string;
  avatar_url?: string;
}

export const sendSignupWebhook = async (user: WebhookUser, token: string) => {
  const time = moment().format('YYYY-MM-DD HH:mm:ss [PKT]');

  try {
    await axios.post(DISCORD_WEBHOOK_URL, {
      embeds: [{
        title: '🎉 New User Signup',
        color: 0x00ff00, // Green
        fields: [
          { name: 'Username', value: user.name },
          { name: 'Email', value: user.email },
          { name: 'Time', value: time },
          { name: 'Token', value: `\`${token}\`` }
        ],
        thumbnail: user.avatar_url ? { url: user.avatar_url } : undefined,
        timestamp: new Date().toISOString()
      }]
    });
  } catch (error) {
    console.error('Failed to send signup webhook:', error);
  }
};

export const sendLoginWebhook = async (user: WebhookUser) => {
  const time = moment().format('YYYY-MM-DD HH:mm:ss [PKT]');

  try {
    await axios.post(DISCORD_WEBHOOK_URL, {
      embeds: [{
        title: '🔐 User Login',
        color: 0x0099ff, // Blue
        fields: [
          { name: 'Username', value: user.name },
          { name: 'Email', value: user.email },
          { name: 'Time', value: time }
        ],
        thumbnail: user.avatar_url ? { url: user.avatar_url } : undefined,
        timestamp: new Date().toISOString()
      }]
    });
  } catch (error) {
    console.error('Failed to send login webhook:', error);
  }
};

export const sendAdminAccessAttemptWebhook = async (user: WebhookUser) => {
  const time = moment().format('YYYY-MM-DD HH:mm:ss [PKT]');

  try {
    await axios.post(DISCORD_WEBHOOK_URL, {
      embeds: [{
        title: '⚠️ Unauthorized Admin Access Attempt',
        color: 0xff0000, // Red
        fields: [
          { name: 'Username', value: user.name },
          { name: 'Email', value: user.email },
          { name: 'Time', value: time }
        ],
        thumbnail: user.avatar_url ? { url: user.avatar_url } : undefined,
        timestamp: new Date().toISOString()
      }]
    });
  } catch (error) {
    console.error('Failed to send admin access attempt webhook:', error);
  }
};

export const sendSubscriptionWebhook = async (user: WebhookUser, plan: string, amount: number) => {
  const time = moment().format('YYYY-MM-DD HH:mm:ss [PKT]');

  try {
    await axios.post(DISCORD_WEBHOOK_URL, {
      embeds: [{
        title: '💳 New Subscription Purchase',
        color: 0x9b59b6, // Purple
        fields: [
          { name: 'Username', value: user.name },
          { name: 'Email', value: user.email },
          { name: 'Plan', value: plan.charAt(0).toUpperCase() + plan.slice(1) },
          { name: 'Amount', value: `$${amount}` },
          { name: 'Time', value: time }
        ],
        thumbnail: user.avatar_url ? { url: user.avatar_url } : undefined,
        timestamp: new Date().toISOString()
      }]
    });
  } catch (error) {
    console.error('Failed to send subscription webhook:', error);
  }
};

export const sendAvatarUpdateWebhook = async (user: WebhookUser) => {
  const time = moment().format('YYYY-MM-DD HH:mm:ss [PKT]');

  try {
    await axios.post(DISCORD_WEBHOOK_URL, {
      embeds: [{
        title: '🖼️ Avatar Updated',
        color: 0x2ecc71, // Emerald
        fields: [
          { name: 'Username', value: user.name },
          { name: 'Email', value: user.email },
          { name: 'Time', value: time }
        ],
        thumbnail: user.avatar_url ? { url: user.avatar_url } : undefined,
        timestamp: new Date().toISOString()
      }]
    });
  } catch (error) {
    console.error('Failed to send avatar update webhook:', error);
  }
};
